import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib/utils';
import { DEFAULT_SELECTOR_PAGE_SIZE_OPTIONS } from '../constants';

export interface SelectorPageSizeControlProps {
  pageSize: number;
  onPageSizeChange: (size: number) => void;
  pageSizeOptions?: readonly number[];
  /** pickModal = outline active only; popover = same minimal style */
  variant?: 'minimal' | 'segment';
}

export function SelectorPageSizeControl({
  pageSize,
  onPageSizeChange,
  pageSizeOptions = DEFAULT_SELECTOR_PAGE_SIZE_OPTIONS,
  variant = 'minimal',
}: SelectorPageSizeControlProps) {
  const { t } = useTranslation('asyncSelector');

  return (
    <div className="gap-phx-2 flex items-center">
      <span className="text-phx-sm text-phx-text-muted whitespace-nowrap">
        {t('footer.rowsLabel')}
      </span>
      <div className="gap-phx-3 flex items-center" role="group" aria-label={t('footer.rowsLabel')}>
        {pageSizeOptions.map((size) => {
          const active = pageSize === size;
          return (
            <button
              key={size}
              type="button"
              data-testid={`page-size-option-${size}`}
              aria-pressed={active}
              onClick={() => onPageSizeChange(size)}
              className={cn(
                'text-phx-sm px-phx-1 min-w-[1.75rem] cursor-pointer py-0.5 transition-colors',
                variant === 'minimal' &&
                  (active
                    ? 'border-phx-primary text-phx-text rounded-phx border-2 bg-transparent font-medium'
                    : 'text-phx-text-2 hover:text-phx-text border-2 border-transparent bg-transparent'),
                variant === 'segment' &&
                  (active
                    ? 'border-phx-primary text-phx-primary-active rounded-phx border bg-transparent font-medium'
                    : 'text-phx-text-2 hover:text-phx-text border-phx-border-2 rounded-phx bg-phx-surface border')
              )}
            >
              {size}
            </button>
          );
        })}
      </div>
    </div>
  );
}
